import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { FormHelperText, Select, SelectChangeEvent } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

interface Props {
    itemList: string[];
    label: string;
    value: string;
    width: number;
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
    onChange?: (event: SelectChangeEvent<string>) => void;
}

const AppSelect = ({label, itemList, value, width, disabled, error, helperText, onChange}: Props) => {

    const getFormControlProps = () => {
        return {
            borderBottom: error ? '1px solid #d32f2f' : '1px solid #e2e2e2',
            height: '5rem',
            width: `${width}%`, 

            '& .MuiSelect-icon': {
                backgroundColor: 'transparent',
                color: 'black',
                height: '2.5rem !important',
                top: '-0.2rem !important',
                width: '2.5rem !important'
            },

            '& .MuiFormHelperText-root': {
                color: error ? '#d32f2f !important' : '#737373 !important',
                fontSize: '1.2rem !important',
                lineHeight: '1.5rem',
                marginTop: '0.5rem !important',
            },
        }
    };

    const getSelectDisplayProps = () => {
        return {
            style: {
                backgroundColor: 'transparent',
                fontSize: '1.6rem',
                fontWeight: 600,
                paddingBottom: '0.4rem', 
                paddingTop: '0.9rem',
                textAlign: 'left' as 'left'
            }
        }
    };

    const getSelectLabelProps = (value: string) => {
        return {
            color: error ? '#d32f2f' : '#737373',
            fontSize: '1.6rem',
            fontWeight: 400,
            marginTop: value ? '0.5rem' : '-0.5rem',
            
            '&.Mui-focused': {
                color: error ? '#d32f2f' : '#737373',
                fontSize: '1.6rem',
                marginTop: '0.5rem'
            }
        }
    };

    const getSelectMenuProps = () => {
        return {
            '& .MuiMenu-list': {
                paddingBottom: 0,
                paddingTop: 0,

                '& li.Mui-selected': {
                    backgroundColor: '#e6e6e6',
                    fontWeight: 700
                },

                '& .MuiMenuItem-root': {
                    fontSize: '1.4rem',
                    height: '4rem'
                }
            }
        }
    };

    return(
        <FormControl variant="standard" sx={getFormControlProps()}>
            <InputLabel sx={getSelectLabelProps(value)}>{label}</InputLabel>
            <Select
                disabled={disabled ? true : false}
                disableUnderline
                IconComponent={ArrowDropDownIcon}
                label={label}
                MenuProps={{PaperProps: {sx: getSelectMenuProps()}}}
                onChange={onChange}
                SelectDisplayProps={getSelectDisplayProps()}
                value={value}
            >
                {itemList.map((item, index) => {
                    return (<MenuItem key={index} value={item}>{item}</MenuItem>)
                })}
            </Select>
            {helperText && <FormHelperText className="select-helper-text">{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default AppSelect;
